import React from "react";
import styles from "./DatabaseDetail.module.scss";
import { SonicProjectData } from "../../../../common/classes/SonicProject";
import Form from "../../../../common/forms/Form";
import FormInput from "../../../../common/forms/FormInput";
import { ValType } from "../../../../utils/ValidationFunctions";
import { SonicTermData } from "../../../../common/classes/SonicTerm";
import SelectMultipleTerms from "../../../../common/forms/SelectMultipleTerms";
import { TermType } from "../../../../utils/useTerm";
import { ImageSourceSetData } from "../../../../common/classes/ImageSourceSet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
  project: SonicProjectData;
  handleInputChange: (value: File | string | undefined, name: string) => void;
  projectTypeOptions: [string, string][] | [];
  games: Array<SonicTermData>;
  handleGames: (value: Array<SonicTermData>) => void;
  imgs: Array<File | ImageSourceSetData>;
  deleteImgItem: (img: File | ImageSourceSetData, i: number) => void;
};
const ProjectForm: React.FC<Props> = ({
  project,
  handleInputChange,
  projectTypeOptions,
  games,
  handleGames,
  imgs,
  deleteImgItem,
}) => {
  return (
    <Form handler={() => {}}>
      <div
        className={`${styles["f-databaseDetail__form"]} ${styles["error-space"]}`}
      >
        <FormInput
          id="name"
          type="text"
          label="プロジェクト名"
          label_class={`${styles["f-databaseDetail__form-title"]} ${styles["required-mark"]}`}
          name="sonic_name"
          style_class={styles["f-databaseDetail__form-input"]}
          handler={handleInputChange}
          initial_value={project.name}
          val_type={ValType.NotNull}
        />
      </div>
      <div
        className={`${styles["f-databaseDetail__form"]} ${styles["error-space"]}`}
      >
        <FormInput
          type="select"
          label="プロジェクトカテゴリ"
          name="sonic_type"
          label_class={`${styles["f-databaseDetail__form-title"]} ${styles["required-mark"]}`}
          select_class={styles["f-databaseDetail__form-input"]}
          holder_class={styles["f-databaseDetail__form-input"]}
          handler={handleInputChange}
          val_type={ValType.NotNull}
          initial_value={project.type?.id}
          options={projectTypeOptions}
          placeholder="未選択"
        />
      </div>
      <div
        className={`${styles["f-databaseDetail__form"]} ${styles["error-space"]}`}
      >
        <FormInput
          type="date"
          label="掲載開始日"
          name="sonic_start_date"
          handler={handleInputChange}
          val_type={ValType.NotNull}
          label_class={`${styles["f-databaseDetail__form-title"]} ${styles["required-mark"]}`}
          style_class={styles["f-databaseDetail__form-input"]}
          input_wrap_class={styles["f-databaseDetail__form-date-wrap"]}
          initial_value={project.start_date}
        />
      </div>
      <div
        className={`${styles["f-databaseDetail__form"]} ${styles["error-space"]}`}
      >
        <FormInput
          type="date"
          label="掲載終了日"
          name="sonic_end_date"
          handler={handleInputChange}
          label_class={styles["f-databaseDetail__form-title"]}
          style_class={styles["f-databaseDetail__form-input"]}
          input_wrap_class={styles["f-databaseDetail__form-date-wrap"]}
          initial_value={project.end_date}
        />
      </div>
      <div
        className={`${styles["f-databaseDetail__form"]} ${styles["error-space"]}`}
      >
        <div className={styles["f-databaseDetail__form-title"]}>ゲーム</div>
        <div className={styles["f-databaseDetail__form-box"]}>
          <div className={styles["mygame"]}>
            <div className={styles["mygame-title"]}>{"設定中のゲーム"}</div>
            <ul className={styles["mygame-list"]}>
              {games && games.length > 0 ? (
                games.map((game, i) => <li key={i}>{game.name}</li>)
              ) : (
                <li>{"まだゲームが設定されていないようです。"}</li>
              )}
            </ul>
          </div>
          <SelectMultipleTerms
            termType={TermType.Games}
            termName="ゲーム"
            buttonText="ゲームを選ぶ"
            terms={games}
            handleTerms={handleGames}
            isAdminPage={true}
          />
        </div>
      </div>
      <div
        className={`${styles["f-databaseDetail__form"]} ${styles["error-space"]}`}
      >
        <span className={styles["f-databaseDetail__form-title"]}>
          プロジェクト画像 最大5枚
        </span>
        <div className={styles["f-databaseDetail__form-imgList"]}>
          {imgs && imgs.length ? (
            <div>
              {imgs.map((img, i) => (
                <div key={i}>
                  <div
                    className={`${styles["imageBox"]} ${styles["clickable"]}`}
                    onClick={() => {}}
                  >
                    <img
                      src={
                        img instanceof File
                          ? URL.createObjectURL(img)
                          : img.medium?.url
                      }
                    />
                  </div>
                  <button
                    className={`${styles["f-databaseDetail__form-fileBtn"]} ${styles["delete"]}`}
                    onClick={() => deleteImgItem(img, i)}
                  >
                    <FontAwesomeIcon icon={["fal", "trash-alt"]} />
                    削除
                  </button>
                </div>
              ))}
            </div>
          ) : null}
          {imgs?.length < 5 ? (
            <button
              type="button"
              className={`${styles["f-databaseDetail__form-fileBtn"]} ${styles["add"]}`}
            >
              <FontAwesomeIcon icon={["fal", "plus-circle"]} />
              <FormInput
                type="file"
                label="追加する"
                id="imgs"
                name="sonic_imgs"
                handler={handleInputChange}
                val_type={ValType.File}
              />
            </button>
          ) : null}
        </div>
      </div>
      <div
        className={`${styles["f-databaseDetail__form"]} ${styles["error-space"]}`}
      >
        <FormInput
          id="description"
          type="textarea"
          label="プロジェクト概要"
          label_class={styles["f-databaseDetail__form-title"]}
          name="sonic_description"
          style_class={styles["f-databaseDetail__form-input"]}
          handler={handleInputChange}
          initial_value={project.description}
          rows={16}
        />
      </div>
      <div
        className={`${styles["f-databaseDetail__form"]} ${styles["error-space"]}`}
      >
        <FormInput
          id="requirements"
          type="textarea"
          label="募集概要"
          label_class={styles["f-databaseDetail__form-title"]}
          name="sonic_requirements"
          style_class={styles["f-databaseDetail__form-input"]}
          handler={handleInputChange}
          initial_value={project.requirements}
          rows={16}
        />
      </div>
      <div
        className={`${styles["f-databaseDetail__form"]} ${styles["error-space"]}`}
      >
        <FormInput
          id="confirmations"
          type="textarea"
          label="応募者への質問・確認事項"
          label_class={styles["f-databaseDetail__form-title"]}
          name="sonic_confirmations"
          style_class={styles["f-databaseDetail__form-input"]}
          handler={handleInputChange}
          initial_value={project.confirmations}
          rows={16}
        />
      </div>
    </Form>
  );
};

export default ProjectForm;
